









import { Produto, ProdutosService } from "@/services/produtos.service";
import dayjs from "dayjs";
import { Component, Vue } from "vue-property-decorator";
import FormProduto from "./FormProduto.vue";

@Component({
  components: {
    FormProduto,
  },
})
export default class NovoProduto extends Vue {
  loading = false;
  produto: Produto = {
    idCatalogo: this.$route.params.idCatalogo,
    validoApos: dayjs().startOf("month").format("YYYY-MM-DD"),
    excluido: false,
    exclusivoDiretora: false,
    mostraVenda: true,
    servico: false,
    alertaVencimentoEmDias: null,
  };
  novoProduto(newProd: Produto) {
    if (newProd) {
      if (newProd.idProduto) {
        this.$router.push({
          name: "catalogos-produtos",
          params: { idCatalogo: this.$route.params.idCatalogo },
        });
      }
      if (newProd.ehKit) {
        if (newProd.idProduto) {
          this.$router.push({
            name: "catalogos-produtos-alterar",
            params: { id: newProd.idProduto },
          });
        }
      }
    }
  }

  mounted() {
    if (this.idProduto) {
      this.fetchProduto();
    }
  }

  get idProduto() {
    return this.$route.params.id;
  }

  get idCatalogo() {
    return this.$route.params.idCatalogo;
  }

  async fetchProduto() {
    this.loading = true;
    this.produto = await ProdutosService.obterProduto(this.idProduto);
    this.produto.validoApos = dayjs().startOf("month").format("YYYY-MM-DD");
    this.produto.codigoFornecedor = "";
    this.produto.idProduto = "";
    this.produto.dataAlteracao = "";
    this.produto.dataCriacao = "";
    this.loading = false;
  }
}
